import React from 'react'
import './TableSkeletonLoader.css'

const TableSkeletonLoader = ({ rows = 5, rowHeight = 40, spacing = 12 }) => {
  return (
    <div className="table-skeleton-wrapper">
      {Array(rows)
        .fill()
        .map((_, i) => (
          <div
            key={i}
            data-testid="table-skeleton-line"
            className="table-skeleton-line"
            style={{
              height: `${rowHeight}px`,
              marginBottom: `${spacing}px`,
            }}
          />
        ))}
    </div>
  )
}

export default TableSkeletonLoader
